import _ from 'lodash';

import { getRoomData } from 'arbitrip-common/client/utils/RoomData';

import Currencies from '../../../../utils/Currencies';

/**
 * Pure helpers `RoomGroups.react.js` reads: board precedence, refundability, price formatting,
 * room-details resolution and the card-title eligibility rule. No React.
 */

const PRICE_PRECISION = 0;

/**
 * Board vocabulary and its precedence, mirroring `DealComponent.getAmenities()`. First match wins,
 * so a deal carries exactly one board label; no match means the rate sells the room alone.
 */
export const BOARD_PRECEDENCE = [
    ['board_bases.all_inclusive', 'CateringAllInclusive'],
    ['board_bases.full_board', 'CateringFullBoard'],
    ['board_bases.half_board', 'CateringHalfBoard'],
    ['breakfast', 'BreakfastIncluded'],
];
export const KEY_ROOM_ONLY = 'RoomGroupsRoomOnly';

const SOURCE_CATALOG = 'RoomGroupsSourceCatalog';
const SOURCE_GROUP = 'RoomGroupsSourceGroup';

const CARD_TITLE_ELIGIBLE_PATH = 'room_display_group.card_title_eligible';

/**
 * `chooseprod` deals carry refundability under `dca`; `S:` deals carry a plain `refundable` flag.
 * Same split as `DealComponent.getCancellation()`.
 */
export function isNonRefundable(deal) {
    if (deal.chooseprod) {
        return Boolean(_.get(deal, 'chooseprod.dca.nonRefundable'));
    }
    return !deal.refundable;
}

export function refundableTill(deal) {
    return _.get(deal, 'chooseprod.dca.dealIsFullyRefundableTill') || deal.freeCancellationUntil || null;
}

export function formatPrice(value, profile) {
    if (!_.isFinite(value)) {
        return '—';
    }
    return Currencies.getPriceWithDisplayCurrencyByDefaultPrecision(
        value,
        _.get(profile, 'display_currency_exchange_rate'),
        _.get(profile, 'display_currency'),
        PRICE_PRECISION,
    );
}

export function roomDataFor(hotel, deal) {
    const catalog = getRoomData(hotel, deal);
    if (catalog) {
        return { data: catalog, source: SOURCE_CATALOG };
    }
    if (deal.room_group_details) {
        return { data: deal.room_group_details, source: SOURCE_GROUP };
    }
    return null;
}

/**
 * MAY THIS DEAL'S OWN STRING TITLE ITS CARD? — `CF-108`(b), `RULINGS_2026-09-24-B` §72.5(b) / §75.7.
 *
 * Only a PRESENT `false` excludes. `true` and ABSENT both admit: absent is every deal from an engine that
 * does not write `card_title_eligible`, and it must read exactly as before the field existed. Reads the
 * shared `room_display_group` object and never writes to it; the deal's own names are not touched (SD-19).
 */
export function isCardTitleEligible(deal) {
    return _.get(deal, CARD_TITLE_ELIGIBLE_PATH) !== false;
}
